import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MainSection from "../../components/mainLayout/Main";
import { DatePicker, message } from "antd";
import { useDispatch, useSelector } from "react-redux";//eslint-disable-next-line
import { useNavigate, useParams } from "react-router-dom";
import { getAllEmployees, getOneClient, createTask } from "../../redux/actions/authActions";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";
import { VscTrash } from "react-icons/vsc";

const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry"
];

function CreateTask() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId");
  
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
    task: "",
    dueDate: "",
    assignee: "",
    document: null,
    description: "", 
  });
  const [locations, setLocations] = useState([
    { state: "", location: "" }
  ]);

  const handleLocationChange = (index, field, value) => {
    const updated = [...locations];
    updated[index][field] = value;
    setLocations(updated);
  };

  const handleAddLocation = () => {
    setLocations([...locations, { state: "", location: "" }]);
  };

  const handleRemoveLocation = (index) => {
    if (locations.length > 1) {
      setLocations(locations.filter((_, i) => i !== index));
    } else {
      setLocations([{ state: "", location: "" }]);
    }
  };

  const client = useSelector((state) => state.auth.client);
  const team = useSelector((state) => state.auth.allEmployees);

  useEffect(() => {
    dispatch(getOneClient(clientId));
    dispatch(getAllEmployees());
  }, [dispatch, clientId]);

  useEffect(() => {
    if (client) setServices(client.services);
  }, [client]);

//   const handleSubmit = async () => {
//   try {
//     // Validations
//     if (!formData.task) return message.error("Task is not selected");
//     if (!formData.dueDate) return message.error("Due date is required");
//     if (!formData.assignee) return message.error("Please select an assignee");
//     if (!formData.document) return message.error("No document uploaded");
// 
//     // Creating FormData
//     const finalFormData = new FormData();
//     finalFormData.append("task", formData.task);
//     finalFormData.append("dueDate", formData.dueDate);
//     finalFormData.append("assignee", formData.assignee);
//     finalFormData.append("description", formData.description); // Ensure this is appended
//     finalFormData.append("document", formData.document); // Must match .fields([{ name: "document" }])
// 
//     await dispatch(createTask(finalFormData, clientId));
//     message.success("Task created successfully");
//     navigate(`/task-management/view-client?clientId=${clientId}`);
//   } catch (err) {
//     console.error("Frontend Error:", err);
//     message.error("Failed to create task");
//   }
// };
const handleSubmit = async () => {
    try {
      // 1. Validations: Remove the document check
      if (!formData.task) return message.error("Task is not selected");
      if (!formData.dueDate) return message.error("Due date is required");
      if (!formData.assignee) return message.error("Please select an assignee");

      // Filter valid locations
      const validLocations = locations.filter(
        (l) => (l.state && l.state.trim()) || (l.location && l.location.trim())
      );

      // 2. Creating FormData
      const finalFormData = new FormData();
      finalFormData.append("task", formData.task);
      finalFormData.append("dueDate", formData.dueDate);
      finalFormData.append("assignee", formData.assignee);
      finalFormData.append("description", formData.description);
      finalFormData.append("locations", JSON.stringify(validLocations));

      // Derive fallback state & location strings for legacy views
      const uniqueStates = [...new Set(validLocations.map((l) => l.state?.trim()).filter(Boolean))];
      finalFormData.append("state", uniqueStates.join(", "));

      const locSummaries = validLocations
        .filter((l) => l.location?.trim() || l.state?.trim())
        .map((l) => {
          const locName = l.location?.trim() || "";
          const stName = l.state?.trim() || "";
          if (locName && stName) return `${locName} (${stName})`;
          return locName || stName;
        });
      finalFormData.append("location", locSummaries.join(", "));

      // 3. Conditional File Append: Only add to FormData if a file exists
      if (formData.document) {
        finalFormData.append("document", formData.document);
      }

      await dispatch(createTask(finalFormData, clientId));
      message.success("Task created successfully");
      navigate(`/task-management/view-client?clientId=${clientId}`);
    } catch (err) {
      console.error("Frontend Error:", err);
      message.error("Failed to create task");
    }
  };
  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Sidebar />
      <MainSection>
        <SectionHeader title="Create Task" />

        <div className="container mx-auto px-4 py-8 max-w-2xl bg-white rounded-xl shadow-lg">
          {/* Task Select */}
          <div className="my-5">
            <label className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Task Name <span className="text-red-500">*</span></label>
            <select
              className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
              value={formData.task}
              onChange={(e) => setFormData({ ...formData, task: e.target.value })}
            >
              <option value="">Select Task</option>
              {services?.map((s) => (
                <option value={s._id} key={s._id}>{s.name}</option>
              ))}
            </select>
          </div>

          {/* Due Date */}
          <div className="mb-5">
            <label className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Due Date <span className="text-red-500">*</span></label>
            <DatePicker
              className="bg-gray-50 border border-gray-300 rounded-lg block w-full p-2.5"
              onChange={(date) => setFormData({ ...formData, dueDate: date ? date.toISOString() : "" })}
              minDate={dayjs()}
            />
          </div>

          {/* Assignee */}
          <div className="mb-5">
            <label className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Assignee <span className="text-red-500">*</span></label>
            <select
              onChange={(e) => setFormData({ ...formData, assignee: e.target.value })}
              className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
            >
              <option value="">Select Team Member</option>
              {team?.map((t) => (
                <option value={t._id} key={t._id}>{t.name}</option>
              ))}
            </select>
          </div>

          {/* Description - NEW FIELD */}
          <div className="mb-5">
            <label className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Description <span className="text-red-500">*</span></label>
            <textarea
              className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
              rows="3"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Enter task details..."
            />
          </div>

          {/* Dynamic Branches / Locations */}
          <div className="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-xl">
            <div className="flex justify-between items-center mb-3">
              <label className="text-xs font-bold text-gray-600 uppercase tracking-wider">
                Branches / Locations ({locations.length})
              </label>
              <button
                type="button"
                onClick={handleAddLocation}
                className="flex items-center gap-1 text-xs font-semibold text-[#045B9B] hover:text-[#03406d] bg-blue-50 hover:bg-blue-100 border border-blue-200 px-3 py-1.5 rounded-lg transition-colors cursor-pointer"
              >
                <AiOutlinePlus className="text-sm" /> Add Branch / Location
              </button>
            </div>

            <div className="space-y-3">
              {locations.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row gap-3 items-center bg-white p-3 rounded-lg border border-gray-200 shadow-sm"
                >
                  <div className="w-full sm:w-1/2">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">
                      State #{index + 1}
                    </label>
                    <select
                      className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      value={item.state}
                      onChange={(e) => handleLocationChange(index, "state", e.target.value)}
                    >
                      <option value="">Select State</option>
                      {INDIAN_STATES.map((st) => (
                        <option key={st} value={st}>{st}</option>
                      ))}
                    </select>
                  </div>

                  <div className="w-full sm:w-1/2">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">
                      Branch / City
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      value={item.location}
                      onChange={(e) => handleLocationChange(index, "location", e.target.value)}
                      placeholder="e.g. Visakhapatnam, Bangalore..."
                    />
                  </div>

                  <div className="flex items-end self-end sm:self-center pt-2 sm:pt-4">
                    <button
                      type="button"
                      disabled={locations.length === 1 && !item.state && !item.location}
                      onClick={() => handleRemoveLocation(index)}
                      className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                      title="Remove Branch"
                    >
                      <VscTrash size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Document Upload Logic (Keep your existing file UI here) */}
          <div className="mb-5">
            <label className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Upload Document</label>
            {/* ... Your existing file dropzone code ... */}
            <input 
               type="file" 
               onChange={(e) => setFormData({...formData, document: e.target.files[0]})}
            />
          </div>

          <button
            onClick={handleSubmit}
            className="w-full py-2 px-4 rounded-full text-white bg-[#045B9B] hover:bg-[#3385c0] font-medium"
          >
            Create Task
          </button>
        </div>
      </MainSection>
    </div>
  );
}

export default CreateTask;